import {DateTime, Duration} from "luxon";

const DATE_TIME_FORMAT = 'dd.LL.yyyy HH:mm:ss'
const DATE_FORMAT = 'dd.LL.yyyy'
const ISO_OPTIONS = {includeOffset: false, suppressMilliseconds: true}

export const dateFilter = (value: string) => {
  if (!value) return;
  else return DateTime.fromISO(value).toFormat(DATE_TIME_FORMAT);
}

export const onlyDateFilter = (value: string) => {
  if (!value) return;
  else return DateTime.fromISO(value).toFormat(DATE_FORMAT);
}

export const timeFilter = (value: number) => {
  if (!value) return;
  else return Duration.fromObject({milliseconds: value}).toFormat('hh:mm:ss');
}

export const currentDate = () => {
  return DateTime.local().plus({minute:1})
    .set({second: 0, millisecond: 0})
    .toISO(ISO_OPTIONS)
}

export const currentDateEnd = () => {
  return DateTime.local()
    .set({hour:23, minute:59, second: 0, millisecond: 0})
    .toISO(ISO_OPTIONS)
}

export const currentDay = () => {
  return DateTime.local()
    .set({second: 0, millisecond: 0})
    .toFormat('yyyy-LL-dd')
}

export const beginningOfCurrentDay = () => {
  return DateTime.local()
    .set({hour: 0, minute: 0, second: 0, millisecond: 0})
    .toISO(ISO_OPTIONS)
}

export const beginningOfCurrentHour = () => {
  return DateTime.local()
    .set({hour: 0, minute: 0, second: 0, millisecond: 0})
    .toISO(ISO_OPTIONS)
}

export const convertDateFromIsoString = (date:string) => {
  return DateTime.fromISO(date);
}

export const convertToHourFormat = (date:DateTime) => {
  return date.toFormat('dd.LL HH:mm');
}

export const convertToDayFormat = (date:DateTime) => {
  return date.toFormat('dd.LL');
}

export const convertToMonthFormat = (date:DateTime) => {
  return date.toFormat('LL');
}

export const toISOMonth = (value: DateTime): string => {
  return value?.toFormat('yyyy-LL-dd') ?? ''
}

export const maxOneMonth = (fromDate: any):any => {
  let jsDate = new Date(fromDate);
  return toISOMonth(DateTime.fromJSDate(jsDate).plus({month: +1}));
}

export const minOneMonth = (fromDate: any):any => {
  let jsDate = new Date(fromDate);
  return toISOMonth(DateTime.fromJSDate(jsDate).plus({month: -1}));
}